import React from 'react'

import './spinner.css'

const Spinner = () => (
  <div className="spinner-cube">
    <div className="spinner-cube-part spinner-cube-cube1" />
    <div className="spinner-cube-part spinner-cube-cube2" />
    <div className="spinner-cube-part spinner-cube-cube4" />
    <div className="spinner-cube-part spinner-cube-cube3" />
  </div>
)

export default Spinner
